<script lang="ts" setup>
import { KirbyStudentPreviewData } from "@/queries/student"

import StudentPagination from "@/components/StudentPage/StudentPagination.vue"
import StudentItem from "@/components/StudentPage/StudentItem.vue"

defineProps<{
  students: KirbyStudentPreviewData[]
}>()
</script>

<template>
  <div><slot /></div>
  <div class="mt-4">
    <StudentPagination>
      <div v-for="student in students" :key="student.id">
        <StudentItem v-if="student" :student="student" />
      </div>
    </StudentPagination>
  </div>
</template>
